import { colors } from 'ui/theme/colors';
import { SvgIcon, SvgIconProps } from '../SvgIcon';
import { getColor } from '../utils';

export const Android24 = ({
  height = 24,
  width = 24,
  color = colors.black,
  isColorInherited = false,
  ...props
}: SvgIconProps) => (
  <SvgIcon height={height} width={width} viewBox="1 0 24 24" {...props}>
    {/* adjusted viewbox slightly to center */}
    <path
      d="M16.375 18.2188H9.625C9.32663 18.2188 9.04048 18.1002 8.8295 17.8892C8.61853 17.6783 8.5 17.3921 8.5 17.0938V12.5938H17.5V17.0938C17.5 17.3921 17.3815 17.6783 17.1705 17.8892C16.9595 18.1002 16.6734 18.2188 16.375 18.2188Z"
      fill={getColor(color, isColorInherited)}
      stroke={getColor(color, isColorInherited)}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M13 5.84375C11.8065 5.84375 10.6619 6.31786 9.81802 7.16177C8.97411 8.00568 8.5 9.15028 8.5 10.3438H17.5C17.5 9.7528 17.3836 9.16764 17.1575 8.62167C16.9313 8.07571 16.5998 7.57963 16.182 7.16177C15.7641 6.74391 15.268 6.41244 14.7221 6.18629C14.1761 5.96015 13.5909 5.84375 13 5.84375Z"
      fill={getColor(color, isColorInherited)}
      stroke={getColor(color, isColorInherited)}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M6.25 15.9688V14.8438C6.25 14.247 6.48705 13.6747 6.90901 13.2528C7.33097 12.8308 7.90326 12.5938 8.5 12.5938H17.5C18.0967 12.5938 18.669 12.8308 19.091 13.2528C19.5129 13.6747 19.75 14.247 19.75 14.8438V15.9688"
      stroke={getColor(color, isColorInherited)}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path d="M9.625 18.2188V20.5618V18.2188Z" fill={getColor(color, isColorInherited)} />
    <path
      d="M9.625 18.2188V20.5618"
      stroke={getColor(color, isColorInherited)}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path d="M16.375 18.2188V20.5618V18.2188Z" fill={getColor(color, isColorInherited)} />
    <path
      d="M16.375 18.2188V20.5618"
      stroke={getColor(color, isColorInherited)}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path d="M9.96175 7.0235L7.9375 5L9.96175 7.0235Z" fill={getColor(color, isColorInherited)} />
    <path
      d="M9.96175 7.0235L7.9375 5"
      stroke={getColor(color, isColorInherited)}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path d="M16.0383 7.0235L18.0626 5L16.0383 7.0235Z" fill={getColor(color, isColorInherited)} />
    <path
      d="M16.0383 7.0235L18.0626 5"
      stroke={getColor(color, isColorInherited)}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </SvgIcon>
);
